import { CallLogCategoryType } from 'Components/CallLogs/types';

export const typesOfCallsId: CallLogCategoryType[] = [
  'missed',
  'outgoing',
  'incoming',
  'all',
];

export interface CallLogsQueryParams {
  typeOfCallId?: CallLogCategoryType;
  query?: string;
  phoneNumbers?: string[];
  personId?: string;
  enabled?: boolean;
  refetchInterval?: number | (() => number);
}

export interface IFetchCallLogs {
  pageParam?: string;
  callId: CallLogCategoryType;
  query: string;
  phoneNumbers?: string[];
  personId?: string;
}

export interface CallLogsMissedCountQueryParams {
  since: number;
}
export interface IFetchCallLogsMissedCount {
  since: number;
}

export interface CallLogsBulkDeleteRequest {
  ids: number[];
}

export interface CallLogsBulkDeleteResponse {
  requestedIds: number[];
  deletedIds: number[];
  failed: number[];
}